






import { Component, Vue } from "vue-property-decorator";
import CardMenu from "../../components/CardMenu.vue";
import { CardMenuItem } from "../../interfaces/card-menu.interface";
import TranslationApiAgent from "../../services/translation-api-agent";
import ProgramsApiAgent from '@/services/programs-api-agent';

// @ts-ignore
@Component({
  components: {
    "card-menu": CardMenu
  }
})
export default class AdminPrograms extends Vue {
  private programs: CardMenuItem[] = [];
  constructor(
    private programsApiAgent = ProgramsApiAgent,
    private translationsApiAgent = TranslationApiAgent
  ) {
    super();
  }

  mounted() {
    this.programsApiAgent.getAll().then(result => {
      this.programs.push({
        route: "/admin/programs/new",
        title: this.translationsApiAgent.get("admin::programs::new")
      });
      result.forEach(n => {
        this.programs.push({
          route: "/admin/programs/" + n.id,
          title: n.from.toLocaleDateString() + ' - ' + n.content
        });
      });
    });
  }
}
